import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=05477244&scoped=true&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"
import style0 from "./Services.vue?vue&type=style&index=0&id=05477244&scoped=true&lang=stylus&"
import style1 from "./Services.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05477244",
  null
  
)

component.options.__file = "Services.vue"
export default component.exports